import { render, staticRenderFns } from "./QuickDev.vue?vue&type=template&id=a84983f4"
import script from "./QuickDev.vue?vue&type=script&lang=js"
export * from "./QuickDev.vue?vue&type=script&lang=js"
import style0 from "./QuickDev.vue?vue&type=style&index=0&id=a84983f4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports